import { Radio, Wifi, WifiOff, AlertCircle, Zap } from "lucide-react";
import Layout from "../../layout";
import StatCard from "../../components/basic-reports/dashboard/StatCard";
import MapPlaceholder from "../../components/basic-reports/dashboard/MapPlaceholder";
import SystemConsumptionChart from "../../components/basic-reports/dashboard/SystemConsumptionChart";
import EnergyConsumptionChart from "../../components/basic-reports/dashboard/EnergyConsumptionChart";
import PeakDemandChart from "../../components/basic-reports/dashboard/PeakDemandChart";
import QuickAccess from "../../components/basic-reports/dashboard/QuickAccess";

const Index = () => {
  return (
    <Layout>
      <div className="p-6">
        {/* Stats Row */}
        <div className="grid grid-cols-5 gap-4 mb-6">
          <StatCard
            title="Total Meters"
            value={10000}
            icon={Radio}
            variant="primary"
            trend={{ value: 2.5, isPositive: true }}
          />
          <StatCard
            title="Active Meters"
            value={9500}
            icon={Wifi}
            variant="success"
            trend={{ value: 1.2, isPositive: true }}
          />
          <StatCard
            title="Inactive Meters"
            value={380}
            icon={WifiOff}
            variant="warning"
          />
          <StatCard
            title="Communication Failure"
            value={120}
            icon={AlertCircle}
            variant="destructive"
          />
          <StatCard
            title="Total Energy (24h)"
            value="152,400"
            subtitle="kWh"
            icon={Zap}
            variant="primary"
            trend={{ value: 8.3, isPositive: true }}
          />
        </div>

        {/* Map + Quick Access Row */}
        <div className="grid grid-cols-12 gap-6 mb-6">
          <div className="col-span-9">
            <div className="bg-card rounded-xl border border-border p-5">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="font-heading font-semibold text-foreground">
                    Meter Distribution Map
                  </h3>
                  <p className="text-sm text-muted-foreground mt-0.5">
                    Geographic distribution of smart meters across service area
                  </p>
                </div>
                <div className="flex items-center gap-4 text-xs">
                  <div className="flex items-center gap-1.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary animate-pulse" />
                    <span className="text-muted-foreground">Online</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-warning" />
                    <span className="text-muted-foreground">Warning</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-destructive" />
                    <span className="text-muted-foreground">Offline</span>
                  </div>
                </div>
              </div>
              <MapPlaceholder />
            </div>
          </div>
          <div className="col-span-3">
            <QuickAccess />
          </div>
        </div>

        {/* System Consumption Chart - Full Width */}
        <div className="mb-6">
          <SystemConsumptionChart />
        </div>

        {/* Additional Charts Row */}
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-8">
            <EnergyConsumptionChart />
          </div>
          <div className="col-span-4">
            <PeakDemandChart />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Index;
